<template>
  <div>
    <AddNewAttendance v-if="true" />
  </div>
  <div v-if="false" class="container-fluid mt-5" @click="closeDropdownIfOpen">
    <!-- <div class="container-fluid mt-5" @click="closeDropdownIfOpen"> -->
    <div class="row mb-4">
      <div class="col-md-12 px-0">
        <div
          class="d-flex flex-column flex-sm-row justify-content-sm-between mb-3"
        >
          <div>
            <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
              Event Registration
            </div>
            <div>
              <BackRoute />
            </div>
            <!-- <div class="grey-backg py-2 border-radius-8 col-md-12">
              <router-link
                to="/tenant/attendancecheckin"
                class="text-decoration-none s-18 text-dak"
              >
                <span class="linear-gradient"
                  >Registatration & Checkin > Event Registration</span
                >
              </router-link>
            </div> -->
          </div>
          <div class="actions">
            <el-button
              :color="primarycolor"
              class="text-white border-0"
              round
              :loading="loadingsave"
              size="large"
              @click="onContinue"
              :disabled="
                !selectedEvent.id ||
                selectedGroups.length === 0 ||
                !selectedEvent.name
              "
            >
              <!-- <i
                    class="fas fa-circle-notch fa-spin mr-2 text-white"
                    v-if="loading"
                  ></i> -->
              <span class="text-white">Save</span>
              <span></span>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div
          class="modal"
          tabindex="-1"
          role="dialog"
          id="newActModal"
          :data-toggle="showBtModal"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Create Event</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body" data-toggle="modal">
                <div class="row my-4">
                  <div class="col-md-4 text-md-right">
                    <label for="">Event category</label>
                  </div>
                  <div class="col-md-7">
                    <div class="dropdown">
                      <button
                        class="default-bt border border-danger d-flex justify-content-between w-100 text-left pr-1"
                        type="button"
                        style="
                          border-radius: 4px;
                          border: 1px solid #ced4da;
                          color: #6c757d;
                        "
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span class="ml-3">{{ selectedCategoryName }}</span>
                        <span
                          ><el-icon class="el-icon--right float-right pr-1">
                            <arrow-down /> </el-icon
                        ></span>
                      </button>
                      <div
                        class="dropdown-menu w-100"
                        aria-labelledby="dropdownMenuButton"
                        style="max-height: 350px; overflow-y: auto"
                      >
                        <div class="row w-100 mx-auto">
                          <div class="col-md-12">
                            <el-input
                              type="text"
                              class="w-100"
                              placeholder="Find event"
                              v-model="categorySearchText"
                            />
                          </div>
                        </div>

                        <a
                          class="dropdown-item font-weight-700 small-text py-2 c-pointer"
                          v-for="(category, index) in filteredCategories"
                          :key="index"
                          @click="selectCategory(category)"
                          >{{ category.name }}</a
                        >

                        <!-- Hidden -->
                        <a
                          class="font-weight-bold small-text d-flex justify-content-center py-2 text-decoration-none primary-text c-pointer"
                          style="border-top: 1px solid #002044; color: #136acd"
                          @click="() => (display = true)"
                        >
                          <el-icon class="mr-2">
                            <CirclePlus />
                          </el-icon>
                          Create new event category
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4 text-md-right">
                    <label for="">Event date</label>
                  </div>
                  <div class="col-md-7">
                    <el-date-picker
                      v-model="newAcctivityDate"
                      type="date"
                      format="MM/DD/YYYY"
                      size="large"
                      class="w-100"
                    />
                    <!-- <input
                      type="date"
                      class="form-control"
                      v-model="newAcctivityDate"
                    /> -->
                  </div>
                </div>

                <div class="row py-2 mt-4">
                  <div class="col-md-4 text-md-right">
                    <label for=""></label>
                  </div>
                  <div class="col-md-7 d-flex justify-content-center">
                    <el-button
                      class="default-btn mr-2 secondary-button"
                      data-dismiss="modal"
                      round
                    >
                      Cancel
                    </el-button>
                    <el-button
                      class="ml-2 text-white"
                      :color="primarycolor"
                      round
                      @click="createNewActivity"
                      data-dismiss="modal"
                      :data-toggle="showBtModal"
                      ref="popModal"
                    >
                      Save
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-sm-3 col-md-3 text-sm-right align-self-center"></div>
          <div class="col-md-8 col-sm-6">
            <h5 class="font-weight-bold s-18 text-head">Upload Event Banner</h5>
            <div class="col-md-12" @click="altClick" v-if="imageUrl">
              <div class="row justify-content-center">
                <div class="col-md-7">
                  <img
                    :src="imageUrl"
                    class="w-100 mx-auto mb-2"
                    style="height: auto"
                  />
                </div>
                <div class="col-md-12">
                  <input
                    type="file"
                    ref="binImage"
                    @change="chooseFile"
                    style="display: none"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="!imageUrl"
              class="col-md-10 upload-area"
              @click="altClick"
            >
              <div class="row">
                <div class="col-md-12">
                  <input
                    type="file"
                    ref="binImage"
                    @change="chooseFile"
                    style="display: none"
                  />
                </div>
                <div class="col-md-12 px-0" v-if="!imageUrl">
                  <el-button
                    round
                    color="#EBEDFF"
                    class="upload-area-btn py-4 px-5 w-100"
                    v-if="!imageUrl"
                    >Upload</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!imageUrl"
            class="col-12 col-md-12 d-flex justify-content-center mt-2"
          >
            <div class="col-sm-7 col-md-3 text-head s-18 fw-400">
              No file selected yet.
            </div>
          </div>
        </div>
        <div class="row my-4">
          <div class="col-sm-3 col-md-3 col-lg-3 text-sm-right">
            <label for="" class="fw-500 s-18 text-head text-dak">Event</label>
          </div>
          <div class="col-sm-7 col-md-7">
            <div class="col-md-12 px-0">
              <!-- Find event -->
              <el-dropdown class="w-100" trigger="click">
                <el-input
                  class="w-100"
                  placeholder="Select from events and activities"
                  v-model="selectedEvent.name"
                />
                <template #dropdown>
                  <el-dropdown-menu class="menu-height">
                    <el-dropdown-item
                      v-for="(event, index) in filteredEvents"
                      :key="index"
                      @click="selectEvent(event)"
                      >{{ event.name }}</el-dropdown-item
                    >
                    <el-dropdown-item
                      class="d-flex justify-content-center text-primary font-weight-700"
                      @click="triggerNewEvent"
                      divided
                      ><el-icon>
                        <CirclePlus />
                      </el-icon>
                      Create new event
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div class="row my-3">
          <div
            class="col-sm-3 col-md-3 col-lg-3 text-sm-right align-self-center"
          >
            <label for="" class="fw-500 s-18 text-head text-dak"
              >Event Details</label
            >
          </div>
          <div class="col-sm-7 col-md-7">
            <el-input
              v-model="eventDetails"
              placeholder="Details"
              :rows="3"
              type="textarea"
            />
          </div>
        </div>
        <!-- <div class="row my-3">
          <div
            class="col-sm-3 col-md-3 col-lg-3 text-sm-right align-self-center"
          >
            <label for="" class="fw-500 s-18 text-head text-dak"
              >Event Subclass</label
            >
          </div>
          <div class="col-sm-7 col-md-7">
            <el-input
              v-model="eventDetails"
              placeholder="Details"
              type="text"
            />
          </div>
        </div> -->
        <div class="row my-3">
          <div class="col-sm-3 col-md-3 col-lg-3 text-sm-right">
            <label for="" class="fw-500 s-18 text-head text-dak">Group</label>
          </div>
          <div class="col-sm-7 col-md-7">
            <SubgroupSelect
              v-model="selectedGroups"
              :items="groups"
              :loading="grouploading"
              placeholder="Select group"
              @filteredGroup="setFilterGroups"
              @newgroup="setNewGroup"
            />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-sm-3 col-md-3 col-lg-3 text-sm-right">
            <label for="" class="fw-500 s-18 text-head text-dak"
              >Is this a paid event?</label
            >
          </div>
          <div class="col-sm-7 col-md-7 d-flex">
            <span class="mr-2"><el-checkbox v-model="markAsPaid" /></span>
            <span class="font-weight-500 mt-1 s-18">Mark as Paid Event</span>
          </div>
        </div>
        <div class="row my-3" v-if="markAsPaid">
          <div class="col-sm-3 col-md-3 col-lg-3 text-sm-right">
            <label for="" class="fw-500 s-18 text-head text-dak">Amount</label>
          </div>
          <div class="col-sm-7 col-md-7">
            <el-input
              type="text"
              class="w-100"
              placeholder=" Amount"
              v-model="amount"
            />
            <div
              class="col-md-12 mt-1 d-flex flex-wrap justify-content-end cursor-pointer px-0"
              @click="openPaymentModal"
            >
              <span
                v-if="accountNumber"
                class="primary--text text-head s-12 font-weight-500"
                >{{ accountNumber }}-{{
                  selectedBank ? selectedBank.name : ""
                }}</span
              >
              <u
                class="primary--text text-head font-weight-600"
                v-if="!accountNumber"
                >Set up Payment Gateway now
              </u>
              <u
                class="primary--text text-head font-weight-600"
                v-if="accountNumber"
                ><el-icon><EditPen /></el-icon>Edit
              </u>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 py-2">
            <div class="d-flex justify-content-between align-items-center">
              <div class="mt-2 fw-500 s-24 col-md-4 text-center">
                More Event details
              </div>
              <!-- <hr style="width: 80%" /> -->
              <el-divider class="col-md-6"></el-divider>
              <div class="">
                <el-icon class="angle-icon" @click="toggleTemplate">
                  <ArrowDownBold />
                </el-icon>
              </div>

              <!-- <span class="mt-2" :class="{
                  rollIcon: templateDisplay,
                  closeIcon: !templateDisplay,
                }" @click="toggleTemplate"><el-icon>
                  <ArrowUp />
                </el-icon></span> -->
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <el-collapse-transition class="col-md-12">
            <div v-show="templateDisplay">
              <div class="container-fluid">
                <div class="row mt-4">
                  <div class="col-sm-3 col-md-3 text-sm-right"></div>
                  <div class="col-sm-7 col-md-6 col-lg-5">
                    <div class="col-md-12"></div>
                    <!-- <div class="row">
                      <div class="col-sm-4 align-self-center">
                        <span
                          class="font-weight-700 cursor-pointer"
                          @click="showFreeTab"
                          :class="{ 'active-tab': addFreeClass }"
                          >Free</span
                        >&nbsp;&nbsp;<span class="text-secondary">|</span
                        >&nbsp;&nbsp;<span
                          class="font-weight-700 cursor-pointer"
                          @click="showPaidTab"
                          :class="{ 'active-tab': addPaidClass }"
                          >Paid</span
                        >
                      </div>
                      <div
                        class="col-sm-8 mt-3 mt-sm-0"
                        :class="{
                          'show-amount': addPaidClass,
                          'hide-amount': !addPaidClass,
                        }"
                      >
                        <el-input
                          type="text"
                          class="w-100"
                          placeholder="Enter amount"
                          v-model="amount"
                        />
                      </div>
                    </div> -->
                  </div>
                  <div class="col-sm-2 col-lg-3"></div>

                  <!-- <el-collapse-transition>
                    <div v-show="addPaidClass">
                      <div class="col-12">
                        <div class="row">
                          <div
                            class="col-sm-3 col-md-4 col-lg-4 text-sm-right mt-4 font-weight-600"
                          >
                            Select Bank
                          </div>
                          <div class="col-sm-7 col-md-6 col-lg-5">
                            <div class="dropdown w-100 mt-4">
                              <button
                                class="default-btn w-100 text-left pr-1"
                                type="button"
                                style="
                                  border-radius: 4px;
                                  border: 1px solid #ced4da;
                                  color: #6c757d;
                                "
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                {{
                                  !selectedBank
                                    ? "Select"
                                    : selectedBank.name.length > 27
                                    ? `${selectedBank.name.slice(0, 27)}...`
                                    : selectedBank.name
                                }}
                                <el-icon class="manual-dd-icon float-right pr-1">
                                  <ArrowDown />
                                </el-icon>
                              </button>
                              <div
                                class="dropdown-menu p-2"
                                aria-labelledby="dropdownMenuButton"
                                style="max-height: 350px; overflow-y: auto"
                              >
                                <el-input
                                  type="text"
                                  class="w-100"
                                  placeholder="Search bank"
                                  v-model="bankSearchText"
                                />
                                <a
                                  class="dropdown-item elipsis-items cursor-pointer"
                                  v-for="item in filteredBanks"
                                  :key="item.id"
                                >
                                  <div @click="setBank(item)">
                                    {{ item ? item.name : "" }}
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-2 col-lg-3"></div>
                          <div
                            class="col-sm-3 col-md-4 col-lg-4 text-sm-right mt-4 font-weight-600"
                          >
                            Account Number
                          </div>
                          <div class="col-sm-7 col-md-6 col-lg-5">
                            <el-input
                              type="text"
                              class="w-100 mt-4 input-height"
                              placeholder="Enter account number"
                              v-model="accountNumber"
                              @blur="resolveCustomerDetail"
                            />
                          </div>
                          <div class="col-sm-2 col-lg-3"></div>

                          <div
                            class="col-sm-3 col-md-4 col-lg-4 text-sm-right mt-4 font-weight-600"
                          >
                            Account Name
                          </div>
                          <div class="col-sm-7 col-md-6 col-lg-5">
                            <el-input
                              type="text"
                              class="w-100 mt-4 input-height"
                              placeholder="account name"
                              v-model="accountName"
                              ref="accNameRef"
                              disabled
                            />
                          </div>
                          <div
                            class="col-sm-2 col-lg-3 align-self-center mt-4"
                            v-if="loading"
                          >
                            <div
                              class="spinner-border text-primary"
                              style="width: 3rem; height: 3rem"
                              role="status"
                            >
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>

                          <div
                            class="col-sm-3 col-md-4 col-lg-4 text-sm-right mt-4 font-weight-600"
                          >
                            Income Account
                          </div>
                          <div class="col-sm-7 col-md-6 col-lg-5">
                            <el-dropdown trigger="click" class="w-100 mt-4">
                              <span class="el-dropdown-link w-100">
                                <div
                                  class="d-flex justify-content-between border-contribution text-secondary w-100"
                                  size="large"
                                >
                                  <span>{{
                                    selectedIncomeAccount &&
                                    Object.keys(selectedIncomeAccount).length > 0
                                      ? selectedIncomeAccount.text
                                      : "Select"
                                  }}</span>
                                  <div>
                                    <el-icon class="el-icon--right">
                                      <arrow-down />
                                    </el-icon>
                                  </div>
                                </div>
                              </span>
                              <template #dropdown>
                                <el-dropdown-menu>
                                  <el-dropdown-item
                                    v-for="(itm, indx) in incomeAccount"
                                    :key="indx"
                                    @click="setIncomeAccount(itm)"
                                    >{{ itm.text }}
                                  </el-dropdown-item>
                                </el-dropdown-menu>
                              </template>
                            </el-dropdown>
                          </div>
                          <div class="col-sm-2 col-lg-3"></div>

                          <div
                            class="col-sm-3 col-md-4 col-lg-4 text-sm-right mt-4 font-weight-600"
                          >
                            Cash Account
                          </div>
                          <div class="col-sm-7 col-md-6 col-lg-5">
                            <el-dropdown trigger="click" class="w-100 mt-4">
                              <span class="el-dropdown-link w-100">
                                <div
                                  class="d-flex justify-content-between border-contribution text-secondary w-100"
                                  size="large"
                                >
                                  <span>{{
                                    selectedCashAccount &&
                                    Object.keys(selectedCashAccount).length > 0
                                      ? selectedCashAccount.text
                                      : "Select"
                                  }}</span>
                                  <div>
                                    <el-icon class="el-icon--right">
                                      <arrow-down />
                                    </el-icon>
                                  </div>
                                </div>
                              </span>
                              <template #dropdown>
                                <el-dropdown-menu>
                                  <el-dropdown-item
                                    v-for="(itm, indx) in cashBankAccount"
                                    :key="indx"
                                    @click="setcashBankAccount(itm)"
                                    >{{ itm.text }}
                                  </el-dropdown-item>
                                </el-dropdown-menu>
                              </template>
                            </el-dropdown>
                          </div>
                          <div class="col-sm-2 col-lg-3"></div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-transition> -->
                </div>
                <div class="row my-3">
                  <div
                    class="col-sm-3 col-md-3 text-sm-right align-self-center"
                  >
                    <label for="locationInput" class="fw-500 s-18 text-dak"
                      >Location</label
                    >
                  </div>
                  <div class="col-sm-7 col-md-7">
                    <div class="position-relative">
                      <el-input
                        v-model="searchQuery"
                        placeholder="Search Location"
                        @input="handleSearchInput"
                        @focus="handleInputFocus"
                        :trim="true"
                        clearable
                      />

                      <div
                        v-if="dropdownVisible"
                        class="dropdown-menu w-100 show mt-1 shadow-sm"
                        style="
                          position: absolute;
                          top: 100%;
                          left: 0;
                          max-height: 200px;
                          overflow-y: auto;
                          z-index: 1000;
                          background: white;
                        "
                      >
                        <div v-if="isSearching" class="p-2 text-center">
                          <el-icon class="is-loading"><Loading /></el-icon>
                          <span class="ml-2">Searching...</span>
                        </div>
                        <div v-else>
                          <div
                            v-for="(item, index) in searchResults"
                            :key="index"
                            class="dropdown-item"
                            style="cursor: pointer"
                            @mousedown.prevent
                            @click="selectLocation(item)"
                          >
                            {{ item.display_name }}
                          </div>
                          <div
                            v-if="searchResults.length === 0"
                            class="dropdown-item text-muted"
                          >
                            {{
                              searchQuery.length > 0
                                ? "No results found"
                                : "Start typing to search"
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <el-dropdown
                      trigger="click"
                      class="w-100"
                      v-model="dropdownVisible"
                      @visible-change="handleDropdownToggle"
                    >
                      <span class="el-dropdown-link w-100">
                        <el-input
                          id="locationInput"
                          type="text"
                          placeholder="Search Location"
                          v-model="searchQuery"
                          @input="handleSearchInput"
                          @focus="handleInputFocus"
                          :trim="false"
                          clearable
                        />
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <div v-if="isSearching" class="p-2 text-center">
                            <el-icon class="is-loading"><Loading /></el-icon>
                            <span class="ml-2">Searching...</span>
                          </div>
                          <template v-else>
                            <el-dropdown-item
                              v-for="(item, index) in searchResults"
                              :key="index"
                              @click="selectLocation(item)"
                            >
                              {{ item.display_name }}
                            </el-dropdown-item>
                            <el-dropdown-item
                              v-if="searchResults.length === 0"
                              disabled
                            >
                              {{
                                searchQuery.length > 0
                                  ? "No results found"
                                  : "Start typing to search locations"
                              }}
                            </el-dropdown-item>
                          </template>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown> -->
                  </div>
                </div>
                <!-- <div class="row my-3">
                  <div
                    class="col-sm-3 col-md-3 text-sm-right align-self-center"
                  >
                    <label for="locationInput" class="fw-500 s-18 text-dak"
                      >Location</label
                    >
                  </div>
                  <div class="col-sm-7 col-md-7">
                    <el-dropdown trigger="click" class="w-100">
                      <span class="el-dropdown-link w-100">
                        <el-input
                          type="text"
                          placeholder="Search Location"
                          v-model="searchQuery"
                          @input="handleSearchInput"
                          clearable
                        />
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu v-if="searchResults.length > 0">
                          <el-dropdown-item
                            v-for="(item, index) in searchResults"
                            :key="index"
                            @click="selectLocation(item)"
                          >
                            {{ item.display_name }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                        <el-dropdown-menu v-else>
                          <el-dropdown-item disabled>
                            {{
                              searchQuery.length > 0
                                ? "No results found"
                                : "Start typing to search locations"
                            }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </div>
                </div> -->
                <div class="row mt-4">
                  <div
                    class="col-sm-3 col-md-3 text-sm-right align-self-center"
                  >
                    <label for="" class="fw-500 s-18 text-dak">Slot</label>
                  </div>
                  <div class="col-sm-7 col-md-7">
                    <el-input
                      type="number"
                      class="w-100"
                      v-model="slot"
                      placeholder="slot available"
                    />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-3 col-md-3 text-sm-right align-self-end">
                    <label for="" class="fw-500 s-18 text-dak"
                      >Cut of time</label
                    >
                  </div>
                  <div class="col-sm-7 col-md-7">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="fw-500 s-18 text-dak">Registration</div>
                        <input
                          type="datetime-local"
                          class="form-control"
                          v-model="regCutOffTimer"
                        />
                      </div>
                      <div class="col-md-6">
                        <div class="fw-500 s-18 text-dak">Checkin</div>
                        <input
                          type="datetime-local"
                          class="form-control"
                          v-model="checkinCutOffTime"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-3 col-md-3"></div>
                  <div class="col-sm-7 col-md-7">
                    <div class="fw-500 s-18 text-dak">
                      Registration SMS default message
                    </div>
                    <SenderIdVue
                      @setselectedsenderid="setSelectedSenderIdRegistration"
                    />
                    <el-input
                      v-model="registrationSMS"
                      :rows="4"
                      type="textarea"
                      placeholder="Registration SMS message body"
                      class="mt-3"
                    />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-3 col-md-3"></div>
                  <div class="col-sm-7 col-md-7">
                    <div class="fw-500 s-18 text-dak">
                      Registration Email default message
                    </div>
                    <el-input
                      v-model="registrationEmailSubject"
                      placeholder="Email subject"
                      type="text"
                      class="mt-2"
                    />
                    <el-input
                      v-model="registrationEmail"
                      :rows="4"
                      type="textarea"
                      placeholder="Registration email message body"
                      class="mt-3"
                    />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-3 col-md-3"></div>
                  <div class="col-sm-7 col-md-7">
                    <hr class="w-100" />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-3 col-md-3"></div>
                  <div class="col-sm-7 col-md-7">
                    <div class="fw-500 s-18 text-dak">
                      Checkin SMS default message
                    </div>
                    <SenderIdVue
                      @setselectedsenderid="setSelectedSenderIdCheckin"
                    />
                    <el-input
                      v-model="checkinSMS"
                      :rows="4"
                      placeholder="Checkin SMS message body"
                      type="textarea"
                      class="mt-3"
                    />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-3 col-md-3"></div>
                  <div class="col-sm-7 col-md-7">
                    <div class="fw-500 s-18 text-dak">
                      Checkin Email default message
                    </div>
                    <el-input
                      v-model="checkinEmailSubject"
                      type="text "
                      placeholder="Email Subject"
                      class="mt-2"
                    />
                    <el-input
                      v-model="checkinEmail"
                      :rows="4"
                      type="textarea"
                      placeholder="Checkin email message body"
                      class="mt-3"
                    />
                  </div>
                </div>

                <!-- </div> -->
                <!-- <div class="row mt-3">
                  <div
                    class="col-sm-3 col-md-3 text-sm-right align-self-center"
                  ></div>
                  <div class="col-sm-7 col-md-7 d-flex mt-2">
                    <div class="row">
                      <div class="col-md-12 my-4 fw-400">
                        Kindly add default message for checkin & Registration
                      </div>
                      <div class="col-md-6">
                        <div class="col-md-12 text-head font-weight-600 s-18">
                          SMS
                        </div>
                        <el-tabs type="border-card">
                          <el-tab-pane label="Checkin">
                            <SenderIdVue
                              @setselectedsenderid="setSelectedSenderIdCheckin"
                            />
                            <el-input
                              v-model="checkinSMS"
                              :rows="4"
                              type="textarea"
                              class="mt-2"
                            />
                          </el-tab-pane>
                          <el-tab-pane label="Registration">
                            <SenderIdVue
                              @setselectedsenderid="
                                setSelectedSenderIdRegistration
                              "
                            />
                            <el-input
                              v-model="registrationSMS"
                              :rows="4"
                              type="textarea"
                              class="mt-2"
                            />
                          </el-tab-pane>
                        </el-tabs>
                      </div>
                      <div class="col-md-6">
                        <div
                          class="col-md-12 mt-3 mt-md-0 text-head font-weight-600 s-18"
                        >
                          Email
                        </div>
                        <el-tabs type="border-card">
                          <el-tab-pane label="Checkin">
                            <div class="col-md-12 my-2"></div>
                            <el-input
                              v-model="checkinEmailSubject"
                              type="text "
                              placeholder="Enter subject"
                              class="mt-2"
                            />
                            <div class="col-md-12 my-4"></div>
                            <el-input
                              v-model="checkinEmail"
                              :rows="4"
                              type="textarea"
                              class="mt-2"
                            />
                          </el-tab-pane>
                          <el-tab-pane label="Registration">
                            <el-input
                              v-model="registrationEmailSubject"
                              placeholder="Enter subject"
                              type="text"
                              class="mt-2"
                            />
                            <div class="col-md-12 my-5"></div>
                            <el-input
                              v-model="registrationEmail"
                              :rows="4"
                              type="textarea"
                              class="mt-2"
                            />
                          </el-tab-pane>
                        </el-tabs>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-3 col-md-3 text-sm-right mt-3 align-self-center"
                  >
                    <label for="" class="text-head fw-500 s-18 text-dak"
                      >Cut-off time</label
                    >
                  </div>
                  <div class="col-sm-7 col-md-7 mt-4">
                    <el-tabs type="border-card">
                      <el-tab-pane label="Checkin">
                        <input
                          type="datetime-local"
                          class="form-control my-3"
                          v-model="checkinCutOffTime"
                        />
                      </el-tab-pane>
                      <el-tab-pane label="Registration">
                        <input
                          type="datetime-local"
                          class="form-control my-3"
                          v-model="regCutOffTimer"
                        />
                      </el-tab-pane>
                    </el-tabs>
                  </div>

                  <div class="col-sm-2 col-lg-3"></div>
                </div> -->
              </div>
            </div>
          </el-collapse-transition>
        </div>
        <!-- <div class="container-fluid"> -->

        <!-- <div class="row my-3">
          <div class="col-sm-3 col-md-4 col-lg-4 text-sm-right"></div>
          <div class="col-sm-7 col-md-6 col-lg-5">
            <div class="row">
              <div class="col-md-12 d-flex justify-content-center">
                <el-button
                  :color="primarycolor"
                  class="text-white border-0"
                  round
                  :loading="loadingsave"
                  size="large"
                  @click="onContinue"
                  :disabled="
                    !selectedEvent.id ||
                    selectedGroups.length === 0 ||
                    !selectedEvent.name
                  "
                >
                  <span class="text-white">Save and Continue</span>
                  <span></span>
                </el-button>
              </div>
            </div>
          </div>
        </div> -->
        <div class="row"></div>
      </div>

      <div class="col-lg-3 col-md-1"></div>
    </div>
    <el-dialog
      v-model="showPaymentDetail"
      class="border-radius-20"
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
    >
      <div class="row">
        <div class="col-md-12 col-12">
          <div class="row justify-content-center">
            <div class="col-md-8 fw-500 s-30">Set up Payment Gateway</div>
            <div class="col-md-8 col-11 mt-4">
              <label class="fw-500 text-head s-18" for="">Select Bank</label>
              <div class="dropdown w-100">
                <button
                  class="d-flex justify-content-between border-contribution bg-white w-100 pr-1"
                  type="button"
                  style="
                    height: 44px;
                    border-radius: 4px;
                    border: 1px solid #ced4da;
                    color: #6c757d;
                  "
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span>{{
                    !selectedBank
                      ? "Select"
                      : selectedBank.name.length > 27
                      ? `${selectedBank.name.slice(0, 27)}...`
                      : selectedBank.name
                  }}</span>
                  <el-icon class="pr-1">
                    <ArrowDown :size="20" />
                  </el-icon>
                </button>
                <div
                  class="dropdown-menu p-2"
                  aria-labelledby="dropdownMenuButton"
                  style="max-height: 350px; overflow-y: auto"
                >
                  <el-input
                    type="text"
                    class="w-100"
                    placeholder="Search bank"
                    v-model="bankSearchText"
                  />
                  <a
                    class="dropdown-item elipsis-items cursor-pointer"
                    v-for="item in filteredBanks"
                    :key="item.id"
                  >
                    <div @click="setBank(item)">
                      {{ item ? item.name : "" }}
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-8 col-11 mt-3">
              <label class="fw-500 text-head s-18" for=""
                >Account Number
              </label>
              <el-input
                type="text"
                class="w-100 input-height"
                placeholder="Enter account number"
                v-model="accountNumber"
                @blur="resolveCustomerDetail"
              />
              <div class="col-md-12 d-flex justify-content-end text-right">
                <span class="text-head font-weight-600">{{ accountName }}</span>
                <div class="align-self-center mt-4" v-if="loading">
                  <div
                    class="spinner-border text-primary"
                    style="width: 2rem; height: 2rem"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-md-12">
              <div class="d-flex align-items-center">
                <span><el-radio v-model="flutterwave" size="large" /></span>
                <span>Flutter wave</span>
              </div>
              <div class="d-flex align-items-center">
                <span><el-radio v-model="paystack" size="large" /></span>
                <span>paystack</span>
              </div>
              <div class="d-flex align-items-center">
                <span><el-radio v-model="alatPay" size="large" /></span>
                <span>AlatPay</span>
              </div>
            </div> -->
            <!-- <div class="col-md-8 col-11 mt-3 d-flex">
              <div>
                <label class="fw-500 text-head s-18" for=""> Account Name </label>
                <el-input
                  type="text"
                  class="w-100 input-height"
                  placeholder="account name"
                  v-model="accountName"
                  ref="accNameRef"
                  disabled
                />
              </div>
              
            </div> -->
            <div class="col-md-8 col-11 mt-3">
              <label class="fw-500 text-head s-18" for="">
                Income Account
              </label>
              <el-dropdown trigger="click" class="w-100">
                <span class="el-dropdown-link w-100">
                  <div
                    class="d-flex justify-content-between border-contribution text-secondary w-100"
                  >
                    <span>{{
                      selectedIncomeAccount &&
                      Object.keys(selectedIncomeAccount).length > 0
                        ? selectedIncomeAccount.text
                        : "Select"
                    }}</span>
                    <div>
                      <el-icon class="el-icon--right">
                        <arrow-down />
                      </el-icon>
                    </div>
                  </div>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      v-for="(itm, indx) in incomeAccount"
                      :key="indx"
                      @click="setIncomeAccount(itm)"
                      >{{ itm.text }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="col-md-8 col-11 mt-3">
              <label class="fw-500 text-head s-18" for=""> Cash Account </label>
              <el-dropdown trigger="click" class="w-100">
                <span class="el-dropdown-link w-100">
                  <div
                    class="d-flex justify-content-between border-contribution text-secondary w-100"
                    size="large"
                  >
                    <span>{{
                      selectedCashAccount &&
                      Object.keys(selectedCashAccount).length > 0
                        ? selectedCashAccount.text
                        : "Select"
                    }}</span>
                    <div>
                      <el-icon class="el-icon--right">
                        <arrow-down />
                      </el-icon>
                    </div>
                  </div>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      v-for="(itm, indx) in cashBankAccount"
                      :key="indx"
                      @click="setcashBankAccount(itm)"
                      >{{ itm.text }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="col-md-8 col-11 mt-3">
              <el-button
                @click="Contiue"
                round
                :color="primarycolor"
                class="text-white py-4 w-100"
                >Save
              </el-button>
            </div>
            <div class="col-md-8 col-11 mt-3">
              <el-button @click="cancel" round class="border-0 w-100"
                >Cancel</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      style="border-radius: 20px"
      v-model="showEventModal"
      :width="mdAndUp || lgAndUp || xlAndUp ? `45%` : `90%`"
      top
    >
      <div class="row justify-content-center">
        <div class="col-md-11">
          <div class="col-md-12 text-center s-18 font-weight-600 text-dak mb-4">
            Create New Event
          </div>
          <div class="row my-4">
            <div class="col-md-4 text-md-right">
              <label for="">Event category</label>
            </div>
            <div class="col-md-7">
              <div class="dropdown">
                <button
                  class="default-bt border border-danger d-flex justify-content-between w-100 text-left pr-1"
                  type="button"
                  style="
                    border-radius: 4px;
                    border: 1px solid #ced4da;
                    color: #6c757d;
                  "
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="ml-3">{{ selectedCategoryName }}</span>
                  <span
                    ><el-icon class="el-icon--right float-right pr-1">
                      <arrow-down /> </el-icon
                  ></span>
                </button>
                <div
                  class="dropdown-menu w-100"
                  aria-labelledby="dropdownMenuButton"
                  style="max-height: 350px; overflow-y: auto"
                >
                  <div class="row w-100 mx-auto">
                    <div class="col-md-12">
                      <el-input
                        type="text"
                        class="w-100"
                        placeholder="Find event"
                        v-model="categorySearchText"
                      />
                    </div>
                  </div>

                  <a
                    class="dropdown-item font-weight-700 small-text py-2 c-pointer"
                    v-for="(category, index) in filteredCategories"
                    :key="index"
                    @click="selectCategory(category)"
                    >{{ category.name }}</a
                  >

                  <!-- Hidden -->
                  <a
                    class="font-weight-bold small-text d-flex justify-content-center py-2 text-decoration-none primary-text c-pointer"
                    style="border-top: 1px solid #002044; color: #136acd"
                    @click="createNewCat"
                  >
                    <el-icon class="mr-2">
                      <CirclePlus />
                    </el-icon>
                    Create new event category
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 text-md-right">
              <label for="">Event date</label>
            </div>
            <div class="col-md-7">
              <el-date-picker
                v-model="newAcctivityDate"
                type="date"
                format="MM/DD/YYYY"
                size="large"
                class="w-100"
              />
              <!-- <input
                      type="date"
                      class="form-control"
                      v-model="newAcctivityDate"
                    /> -->
            </div>
          </div>

          <div class="row py-2 mt-4">
            <div class="col-md-4 text-md-right">
              <label for=""></label>
            </div>
            <div class="col-md-7 d-flex justify-content-center">
              <el-button size="large" class="mr-2 secondary-button" round>
                Cancel
              </el-button>
              <el-button
                class="ml-2 text-white"
                :color="primarycolor"
                round
                size="large"
                @click="createNewActivity"
              >
                Save
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-model="showEventCatModal"
      title="Create Event Category"
      class="border-radius-20"
      :width="mdAndUp || lgAndUp || xlAndUp ? `45%` : `90%`"
      align-center
    >
      <div class="row">
        <div class="col-md-12">
          <CreateEventModal
            @new-created="newCategoryCreated"
            @closeeventmodal="closeModal"
          />
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-model="showSubClassModal"
      title=""
      class="border-radius-20"
      :width="mdAndUp || lgAndUp || xlAndUp ? `45%` : `90%`"
      align-center
    >
      <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="row">
            <div class="col-md-12 text-center text-dak fw-500 s-20">
              Add New Subclass
            </div>
            <div class="col-md-12 mt-4">
              <label for="" class="fw-500 s-18 text-head text-dak"
                >Subclass name</label
              >
              <div class="col-md-12 px-0">
                <!-- Find event -->
                <el-dropdown class="w-100" trigger="click">
                  <el-input
                    class="w-100"
                    placeholder="Select from events and activities"
                    v-model="selectedEvent.name"
                  />
                  <template #dropdown>
                    <el-dropdown-menu class="menu-height">
                      <el-dropdown-item
                        v-for="(event, index) in filteredEvents"
                        :key="index"
                        @click="selectEvent(event)"
                        >{{ event.name }}</el-dropdown-item
                      >
                      <el-dropdown-item
                        class="d-flex justify-content-center text-primary font-weight-700"
                        @click="triggerNewEvent"
                        divided
                        ><el-icon>
                          <CirclePlus />
                        </el-icon>
                        Create new event
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
            </div>
            <div class="col-md-12 mt-3">
              <label for="" class="fw-500 s-18 text-head text-dak"
                >Event Details</label
              >
              <el-input
                v-model="eventDetails"
                placeholder="Details"
                :rows="2"
                type="textarea"
              />
            </div>
            <div class="col-md-12 mt-3">
              <label for="" class="fw-500 s-18 text-head text-dak">Group</label>
              <SubgroupSelect
                v-model="selectedGroups"
                :items="groups"
                :loading="grouploading"
                placeholder="Select group"
                @filteredGroup="setFilterGroups"
                @newgroup="setNewGroup"
              />

              <!-- <label class="s-15 text-dak">Assign Minister</label>
              <el-select
                v-model="assignMinisterID"
                filterable
                placeholder="Select Minister"
                class="w-100"
                @change="setAssignMinister"
              >
                <el-option
                  v-for="(item, index) in allAssignMinisters"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select> -->
            </div>
            <div class="col-md-12 mt-3">
              <label class="s-15 text-dak">Amount</label>
              <div class="amount-input-group">
                <el-select
                  v-model="givingForm.currency"
                  class="currency-select mr-2"
                  @change="setSelectedCurrency"
                >
                  <!-- <el-option
                    v-for="currency in supportedCurrencies"
                    :key="currency.value"
                    :label="currency.value"
                    :value="currency.value"
                  /> -->
                  <el-option
                    v-for="currency in currencyList"
                    :key="currency.id"
                    :label="currency.shortCode"
                    :value="currency.id"
                  />
                </el-select>
                <el-input
                  v-model="givingForm.amount"
                  type="number"
                  placeholder="0.00"
                  class="amount-input"
                  min="0"
                  step="0.01"
                />
              </div>
            </div>
            <div class="col-md-12">
              <el-checkbox size="large" v-model="markAsFree" /> Mark as free
            </div>
            <div class="col-md-12 mt-5 mb-3">
              <div
                class="d-flex flex-column align-items-center justify-content-center"
              >
                <el-button
                  class="text-white w-100"
                  :color="primarycolor"
                  round
                  size="large"
                  @click="addNewSubclass"
                  >Save Subclass</el-button
                >
                <el-button
                  class="text-dak w-100"
                  link
                  size="large"
                  @click="closeSubClassModal"
                >
                  <span class="fw-500 mt-3">Cancel</span>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-model="showAddOnModal"
      title=""
      class="border-radius-20"
      :width="mdAndUp || lgAndUp || xlAndUp ? `45%` : `90%`"
      align-center
    >
      <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="row">
            <div class="col-md-12 text-center text-dak fw-500 s-20">
              Add Add-on
            </div>
            <div class="col-md-12 mt-4">
              <label class="s-15 text-dak">Add-on name</label>
              <el-input
                type="text"
                v-model="addOnName"
                placeholder="Enter Subclass name"
                style="background-color: #e9feff !important"
                class="w-100"
              />
            </div>
            <div class="col-md-12 mt-3">
              <label class="s-15 text-dak">Amount</label>
              <div class="amount-input-group">
                <el-select
                  v-model="givingForm.currency"
                  class="currency-select mr-2"
                  @change="setSelectedCurrency"
                >
                  <el-option
                    v-for="currency in currencyList"
                    :key="currency.id"
                    :label="currency.shortCode"
                    :value="currency.id"
                  />
                </el-select>
                <el-input
                  v-model="givingForm.amount"
                  type="number"
                  placeholder="0.00"
                  class="amount-input"
                  min="0"
                  step="0.01"
                />
              </div>
            </div>
            <div class="col-md-12">
              <el-checkbox size="large" v-model="markAsFree" /> Mark as free
            </div>
            <div class="col-md-12 mt-5 mb-3">
              <div
                class="d-flex flex-column align-items-center justify-content-center"
              >
                <el-button
                  class="text-white w-100"
                  :color="primarycolor"
                  round
                  size="large"
                  @click="addNewSubclass"
                  >Save</el-button
                >
                <el-button
                  class="text-dak w-100"
                  link
                  size="large"
                  @click="closeSubClassModal"
                >
                  <span class="fw-500 mt-3">Cancel</span>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { computed, onMounted, nextTick, ref, inject } from "vue";
import { useRoute } from "vue-router";
import router from "@/router/index";
import SubgroupSelect from "../../groups/component/SubgroupSelect.vue";
import BackRoute from "../../../components/backroute/BackRoute.vue";
import groupService from "../../../services/groups/groupsservice";
import eventsService from "../../../services/events/eventsservice";
import CreateEventModal from "../../../components/attendance/AttendanceEventModal";
import AddNewAttendance from "./AddNewAttendance.vue";
// import attendanceservice from "../../../services/attendance/attendanceservice";
import { useStore } from "vuex";
import axios from "@/gateway/backendapi";
import finish from "../../../services/progressbar/progress";
import axio from "axios";
import moment from "moment";
import GroupTree from "../../groups/component/GroupTreeCheckboxParent.vue";
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
import collector from "../../../services/groupArray/mapTree";
import flatten from "../../../services/groupArray/flatTree";
import { ElNotification } from "element-plus";
import SenderIdVue from "../../../components/senderId/SenderId.vue";
import supportedCurrencies from "@/services/user/flutterwaveSupportedCurrency";

const primarycolor = inject("primarycolor");
const store = useStore();
const route = useRoute();
const markAsPaid = ref(false);
const groups = ref([]);
const display = ref(false);
const newActModal = ref(false);
const showBtModal = ref("");
const popModal = ref(null);
const openModalBtn = ref(null);
const addPaidClass = ref(false);
const addFreeClass = ref(true);
const showEventModal = ref(false);
const templateDisplay = ref(false);
const nigerianBanks = ref([]);
const selectedBank = ref("");
const markAsFree = ref(false);
const defaultCurrency = ref({});
const accountNumber = ref("");
const accountName = ref("");
const addOnName = ref("");
// const accNameRef = ref("");
const loading = ref(false);
const loadingsave = ref(false);
const showSubClassModal = ref(false);
const showAddOnModal = ref(false);
const eventDetails = ref("");
const cashBankAccount = ref([]);
const incomeAccount = ref([]);
const selectedIncomeAccount = ref({});
const selectedCashAccount = ref(null);
const registrationSMS = ref("");
const registrationEmail = ref("");
// const selectLocation = ref("");
const checkinSMS = ref("");
const checkinEmail = ref("");
const paystack = ref("");
const flutterwave = ref("");
const alatPay = ref("");
const amount = ref("");
const binImage = ref("");
const image = ref("");
const imageUrl = ref("");
const slot = ref("");
const hideDiv = ref(true);
const searchGroupRef = ref(true);
const showPaymentDetail = ref(false);
const searchGroupText = ref("");
const grouploading = ref(false);
const checkinCutOffTime = ref("");
const regCutOffTimer = ref("");
const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
const checkinSMSSubject = ref("");
const registrationSMSSubject = ref("");
const registrationEmailSubject = ref("");
const checkinEmailSubject = ref("");

const searchQuery = ref("");
const searchResults = ref([]);
const selectedLocation = ref(null);
const dropdownVisible = ref(false);
const isSearching = ref(false);
const debounceTimer = ref(null);
const showEventCatModal = ref(false);
const assignMinisterID = ref(null);
const subclassName = ref("");
const currencyList = ref([]);
const formResponse = ref({});
const selectedAssignMinister = ref({});
const givingForm = ref({
  amount: "",
  currency: "NGN",
});
const setSelectedCurrency = () => {
  defaultCurrency.value = currencyList.value.find(
    (i) => i.shortCode === givingForm.currency
  );
};

const allAssignMinisters = ref([
  { id: 1, name: "John Doe" },
  { id: 2, name: "Jane Smith" },
  { id: 3, name: "Michael Johnson" },
  { id: 4, name: "Emily Davis" },
  { id: 5, name: "David Wilson" },
  { id: 6, name: "Sarah Brown" },
  { id: 7, name: "James Taylor" },
  { id: 8, name: "Olivia Anderson" },
  { id: 9, name: "Daniel Thomas" },
  { id: 10, name: "Sophia Martinez" },
]);

const setAssignMinister = () => {
  selectedAssignMinister.value = allAssignMinisters.value.find(
    (i) => i.id === assignMinisterID.value
  );
};
const loadCurrencies = async () => {
  try {
    const response = await axios.get("/api/LookUp/GetAllCurrencies");
    currencyList.value = response.data;

    // Get the payment form currency
    const userCurrencyObj = currencyList.value.find(
      (i) => i.id === formResponse.value.currencyId
    );

    // Check if the payment currency is supported
    const userCurrencySupported = supportedCurrencies.find(
      (i) => i.value === userCurrencyObj?.shortCode
    );

    // Set default currency
    defaultCurrency.value = userCurrencySupported
      ? userCurrencyObj
      : currencyList.value.find((i) => i.shortCode === "USD");

    givingForm.currency = userCurrencySupported
      ? userCurrencySupported.value
      : "USD";
  } catch (error) {
    console.error("Error loading currencies:", error);
  }
};
loadCurrencies();
const closeSubClassModal = () => {
  showSubClassModal.value = false;
};
const addNewSubclass = () => {
  if (selectedGroups.value.length === 0 || selectedEvent.value.length === 0) {
    ElNotification({
      title: "Error",
      message: "Please fill in all required fields.",
      type: "error",
    });
    return;
  }
  const newSubclass = {
    name: subclassName.value,
    assignedMinister: selectedAssignMinister.value,
    amount: givingForm.amount
      ? `${givingForm.currency} ${parseFloat(givingForm.amount).toFixed(2)}`
      : null,
  };
  // Emit the new subclass to the parent component
  // emit("new-subclass", newSubclass);
  // Reset form fields
  subclassName.value = "";
  assignMinisterID.value = null;
  givingForm.amount = "";
  givingForm.currency = "NGN";
  defaultCurrency.value = currencyList.value.find((i) => i.shortCode === "NGN");
  // Close the modal
  showSubClassModal.value = false;
  ElNotification({
    title: "Success",
    message: "New subclass added successfully.",
    type: "success",
  });
  console.log(newSubclass, "new subclass");
};

// const filteredMinister = computed(() => {
//   if (!assignMinisterID.value) {
//     return allAssignMinisters.value;
//   }
//   return allAssignMinisters.value.filter((minister) =>
//     minister.name
//       .toLowerCase()
//       .includes(assignMinisterID.value.toLowerCase())
//   );
// });

// Initialize Google Autocomplete on input mount
// onMounted(() => {
//   const input = document.getElementById("locationInput");

//   if (!window.google || !window.google.maps) {
//     console.error("Google Maps script not loaded");
//     return;
//   }

//   const autocomplete = new google.maps.places.Autocomplete(input);

//   autocomplete.addListener("place_changed", () => {
//     const place = autocomplete.getPlace();
//     selectLocation.value = place.formatted_address || place.name;
//     console.log("Selected location:", place);
//   });
// });

// const selectedGroup = ref({});
const selectedGroups = ref([]);
const selectedIncomeAccountID = ref(null);
const selectedCashAccountID = ref(null);

const attendanceCheID = ref(route.params.id);
const eventNameDate = ref("");

const setIncomeAccount = (item) => {
  selectedIncomeAccount.value = item;
};
const setGroupValue = () => {
  flattenedTree.value.find((i) => i.value == selectedGroups.value);
};
const setcashBankAccount = (item) => {
  selectedCashAccount.value = item;
};

const openPaymentModal = () => {
  showPaymentDetail.value = true;
};
const Contiue = () => {
  showPaymentDetail.value = false;
};
const cancel = () => {
  showPaymentDetail.value = false;
};
const triggerNewEvent = () => {
  showEventModal.value = true;
};
const createNewCat = () => {
  showEventCatModal.value = true;
};

const getSingleCheckinAttendance = async () => {
  try {
    const res = await axios.get(
      `/api/CheckInAttendance/GetSingleAttendanceCheckIn?checkInAttendanceId=${attendanceCheID.value}`
    );
    // let groupArray = []
    // groupArray.push(res.data.returnObject.attendanceItem.fullGroupName)
    eventNameDate.value = `${
      res.data.returnObject.attendanceItem.fullEventName
    } (${new Date(
      res.data.returnObject.attendanceItem.eventDate
    ).toDateString()})`;
    selectedEvent.value.name = `${
      res.data.returnObject.attendanceItem.fullEventName
    } (${new Date(
      res.data.returnObject.attendanceItem.eventDate
    ).toDateString()})`;
  } catch (error) {
    console.log(error);
  }
};
if (attendanceCheID.value) getSingleCheckinAttendance();

const groupMappedTree = ref([]);
const flattenedTree = ref([]);
const getGroups = async () => {
  grouploading.value = true;
  try {
    const response = await groupService.getGroups();
    grouploading.value = false;
    if (response.response && response.response.groupResonseDTO.length > 0) {
      groups.value = response.response.groupResonseDTO;
    }
    let data = { children: groups.value };
    const { children } = collector(data);
    groupMappedTree.value = children;
    if (groupMappedTree.value && groupMappedTree.value.length > 0) {
      flattenedTree.value = groupMappedTree.value.flatMap(flatten());
    }
  } catch (error) {
    console.log(error);
    grouploading.value = false;
  }
};

const events = ref([]);
const getEvents = async () => {
  try {
    const response = await eventsService.getEvents();
    if (response && response.length > 0) {
      events.value = response.map((i) => {
        return { id: i.activityID, name: i.name, date: i.date };
      });
    }
  } catch (error) {
    console.log(error);
  }
};
const filterNodeMethod = (value, data) =>
  data.label.toLowerCase().includes(value.toLowerCase());
const selectedEvent = ref({});
const selectEvent = (selected) => {
  selectedEvent.value = selected;
  // eventSearchText.value = ''
};

const closeModal = () => {
  // display.value = false;
  showEventCatModal.value = false;
};

const eventCategories = ref([]);
const getEventCategories = async () => {
  try {
    const response = await eventsService.getEventCategories();
    eventCategories.value = response;
  } catch (error) {
    console.log(error);
  }
};
getEventCategories();

const selectedCategory = ref({});
const selectCategory = (category) => {
  selectedCategory.value = category;
  newActModal.value = false;
};

const newAcctivityDate = ref("");
const getCorrectDate = (date) => {
  return new Date(date).toLocaleDateString("en-US").replaceAll("/", "-");
};
const createNewActivity = async () => {
  if (!newAcctivityDate.value && !selectedCategory.value) return false;
  try {
    const response = await eventsService.createNewActivity({
      activity: {
        date: getCorrectDate(newAcctivityDate.value),
        eventCategoryId: selectedCategory.value.id,
      },
    });
    const newActivity = {
      id: response.currentEvent.id,
      name: `${response.currentEvent.name} (${new Date(
        response.currentEvent.activityDate
      ).toDateString()})`,
      date: getCorrectDate(newAcctivityDate.value),
    };
    selectedEvent.value = newActivity;
    events.value.push(newActivity);
    ElNotification({
      message: "Event created successfully",
      type: "success",
      duration: 2000,
    });

    showEventModal.value = false;
  } catch (error) {
    ElNotification({
      type: "error",
      message: "Could not create event",
      duration: 2000,
    });
    console.log(error);
  }
};

const selectedCategoryName = computed(() => {
  if (!selectedCategory.value || !selectedCategory.value.name) return "";
  return selectedCategory.value.name.length > 17
    ? `${selectedCategory.value.name.slice(0, 16)}...`
    : selectedCategory.value.name;
});

const newCategoryCreated = (categories, eventName) => {
  eventCategories.value = categories;
  selectedCategory.value = categories.find(
    (i) => i.name.toLowerCase() === eventName.toLowerCase()
  );
  // openModalBtn.value.click();
  // display.value = false;
  showEventCatModal.value = false;
};

const categorySearchText = ref("");
const filteredCategories = computed(() => {
  if (!categorySearchText.value) return eventCategories.value;
  return eventCategories.value.filter((i) =>
    i.name.toLowerCase().includes(categorySearchText.value.toLowerCase())
  );
});

const bankSearchText = ref("");
const filteredBanks = computed(() => {
  if (!bankSearchText.value) return nigerianBanks.value;
  return nigerianBanks.value.filter((i) =>
    i.name.toLowerCase().includes(bankSearchText.value.toLowerCase())
  );
});

const eventSearchText = ref("");
const filteredEvents = computed(() => {
  if (!selectedEvent.value.name) return events.value;
  return events.value.filter((i) =>
    i.name.toLowerCase().includes(selectedEvent.value.name.toLowerCase())
  );
});

getEvents();
getGroups();
// const searchLocations = async (query) => {
//   if (!query.trim()) {
//     searchResults.value = [];
//     return;
//   }

//   try {
//     const response = await fetch(
//       `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
//         query
//       )}&addressdetails=1`
//     );
//     const data = await response.json();
//     searchResults.value = data;
//   } catch (error) {
//     console.error("Error fetching locations:", error);
//     searchResults.value = [];
//   }
// };

// const handleSearchInput = () => {
//   searchLocations(searchQuery.value);
// };

// const searchLocations = async (query) => {
//   if (!query.trim()) {
//     searchResults.value = [];
//     return;
//   }

//   isSearching.value = true;

//   try {
//     const response = await fetch(
//       `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
//         query
//       )}&addressdetails=1`
//     );

//     if (!response.ok) throw new Error("Network response was not ok");

//     const data = await response.json();
//     searchResults.value = data;

//     if (data.length > 0) {
//       dropdownVisible.value = true;
//     }
//   } catch (error) {
//     console.error("Error fetching locations:", error);
//     searchResults.value = [];
//     ElNotification({
//       type: "error",
//       message: "Failed to fetch locations",
//       duration: 3000,
//     });
//   } finally {
//     isSearching.value = false;
//   }
// };
// const handleSearchInput = () => {
//   clearTimeout(debounceTimer.value);
//   debounceTimer.value = setTimeout(() => {
//     searchLocations(searchQuery.value);
//   }, 500);
// };
const searchLocations = async (query) => {
  if (!query.trim()) {
    searchResults.value = [];
    return;
  }

  isSearching.value = true; // Should trigger the spinner

  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
        query
      )}&addressdetails=1`
    );
    if (!response.ok) throw new Error("Failed to fetch");
    const data = await response.json();
    searchResults.value = data;
  } catch (error) {
    searchResults.value = [];
    ElNotification({
      type: "error",
      message: "Failed to fetch locations",
      duration: 3000,
    });
    console.error(error);
  } finally {
    isSearching.value = false; // Hides spinner after API call completes
  }
};
const handleSearchInput = () => {
  clearTimeout(debounceTimer.value);
  debounceTimer.value = setTimeout(() => {
    searchLocations(searchQuery.value).then(() => {
      dropdownVisible.value = searchResults.value.length > 0;
    });
  }, 500);
};
const handleInputFocus = () => {
  if (searchQuery.value && searchResults.value.length > 0) {
    dropdownVisible.value = true;
  }
};
const handleDropdownToggle = (visible) => {
  if (visible && searchQuery.value && searchResults.value.length === 0) {
    // Re-search when dropdown is manually opened
    searchLocations(searchQuery.value);
  }
};

const selectLocation = (location) => {
  selectedLocation.value = {
    display_name: location.display_name,
    address: {
      road: location.address?.road || "",
      city: location.address?.city || location.address?.town || "",
      state: location.address?.state || "",
      country: location.address?.country || "",
      postal_code: location.address?.postcode || "",
    },
    coordinates: {
      lat: parseFloat(location.lat),
      lon: parseFloat(location.lon),
    },
  };

  searchQuery.value = location.display_name;
  dropdownVisible.value = false; // ✅ close the dropdown
  console.log("Selected location:", selectedLocation.value);
  // You can emit this to parent component or save to backend
};

const onContinue = async () => {
  loadingsave.value = true;

  const formData = new FormData();

  image.value ? formData.append("bannerPhoto", image.value) : "";
  formData.append("details", eventDetails.value);
  formData.append("address", searchQuery.value ? searchQuery.value : "");
  formData.append(
    "lat",
    selectedLocation.value ? selectedLocation.value.coordinates.lat : ""
  );
  formData.append(
    "lon",
    selectedLocation.value ? selectedLocation.value.coordinates.lon : ""
  );
  selectedBank.value
    ? formData.append(
        "bankCode",
        selectedBank.value ? selectedBank.value.code : ""
      )
    : "";
  accountName.value ? formData.append("accountName", accountName.value) : "";
  accountNumber.value
    ? formData.append("accountNumber", accountNumber.value)
    : "";
  formData.append("contributionItemName", selectedEvent.value.name);
  selectedCashAccount.value
    ? formData.append(
        "cashAccountId",
        selectedCashAccount.value ? selectedCashAccount.value.id : ""
      )
    : "";
  selectedIncomeAccount.value && selectedIncomeAccount.value.id
    ? formData.append(
        "incomeAccountId",
        selectedIncomeAccount.value && selectedIncomeAccount.value.id
          ? selectedIncomeAccount.value.id
          : ""
      )
    : "";
  registrationSMS.value
    ? formData.append("registrationSMS", registrationSMS.value)
    : "";
  registrationSMSSubject.value
    ? formData.append("registrationSMSSubject", registrationSMSSubject.value)
    : "";
  registrationEmail.value
    ? formData.append("registrationEmail", registrationEmail.value)
    : "";
  registrationEmailSubject.value
    ? formData.append(
        "registrationEmailSubject",
        registrationEmailSubject.value
      )
    : "";
  checkinSMS.value ? formData.append("checkinSMS", checkinSMS.value) : "";
  checkinSMSSubject.value
    ? formData.append("checkInSMSSubject", checkinSMSSubject.value)
    : "";
  checkinEmail.value ? formData.append("checkinEmail", checkinEmail.value) : "";
  checkinEmailSubject.value
    ? formData.append("checkinEmailSubject", checkinEmailSubject.value)
    : "";
  selectedEvent.value
    ? formData.append("activityDate", getCorrectDate(selectedEvent.value.date))
    : "";
  // formData.append("isPaidFor", addPaidClass.value);
  formData.append("isPaidFor", markAsPaid.value);
  amount.value ? formData.append("amount", amount.value) : "";
  selectedEvent.value
    ? formData.append("activityId", selectedEvent.value.id)
    : "";

  formData.append("enableRegistration", true);
  slot.value ? formData.append("registrationSlot", slot.value) : "";
  regCutOffTimer.value
    ? formData.append("registrationCutOffTime", regCutOffTimer.value)
    : "";
  checkinCutOffTime.value
    ? formData.append("checkInCutOffTime", checkinCutOffTime.value)
    : "";
  selectedGroups.value
    ? formData.append("groupIDs", JSON.stringify(selectedGroups.value))
    : "";

  if (attendanceCheID.value) {
    attendanceCheID.value ? formData.append("Id", attendanceCheID.value) : "";
    loadingsave.value = true;
    try {
      const res = await axios.put(
        "/api/CheckInAttendance/EditAttendanceCheckIn",
        formData
      );
      console.log(res);
      store.dispatch("attendance/setItemData", res);
      ElNotification({
        type: "success",
        message: res.data.response,
        duration: 5000,
      });
      store.dispatch("attendance/setAttendanceItemData");
      router.push({
        name: "CheckinType",
        query: {
          activityID: selectedEvent.value.id,
          activityName: selectedEvent.value.name,
          groupId: selectedGroups.value[0].id,
          groupName: selectedGroups.value[0].name,
          id: res.data.id,
          code: res.data.attendanceCode,
        },
      });
    } catch (error) {
      console.log(error);
    }
  } else {
    try {
      const response = await axios.post(
        "api/CheckInAttendance/CreateAttendanceCheckIn",
        formData
        // "/api/CheckinAttendance/MultipleCheckinAttendanceItem",
        // checkinEvent
      );
      for (
        let i = 0;
        i < response.data.returnObject.checkInAttendanceResult.length;
        i++
      ) {
        const element = response.data.returnObject.checkInAttendanceResult[i];
        store.dispatch("attendance/setItemData", element);
      }
      store.dispatch("attendance/setAttendanceItemData");
      store.dispatch("groups/setCheckedTreeGroup", []);
      loadingsave.value = false;
      router.push({
        name: "CheckinType",
        query: {
          activityID: selectedEvent.value.id,
          activityName: selectedEvent.value.name,
          groupId: selectedGroups.value[0].id,
          groupName: selectedGroups.value[0].name,
          id: response.data.returnObject.checkInAttendanceResult[0].id,
          code: response.data.returnObject.checkInAttendanceResult[0]
            .attendanceCode,
        },
      });
    } catch (error) {
      console.log(error);
      loadingsave.value = false;
    }
  }
  //         if (
  //   !attendanceCheID.value &&
  //   !amount.value &&
  //   !selectedBank.value &&
  //   !accountNumber.value &&
  //   !selectedCashAccount.value &&
  //   !selectedIncomeAccount.value &&
  //   !image.value
  // ) {
  //   console.log("free and no image");
  //   selectedGroups.value
  //     ? formData.append("groupIDs", JSON.stringify(selectedGroups.value))
  //     : "";
  //   loadingsave.value = true;
  //   try {
  //     const response = await axios.post(
  //       "api/CheckInAttendance/CreateAttendanceCheckIn", formData
  //       // "/api/CheckinAttendance/MultipleCheckinAttendanceItem",
  //       // checkinEvent
  //     );
  //     for (let i = 0; i < response.data.returnObject.checkInAttendanceResult.length; i++) {
  //       const element = response.data.returnObject.checkInAttendanceResult[i];
  //       store.dispatch("attendance/setItemData", element);
  //     }
  //     store.dispatch('attendance/setAttendanceItemData');
  //     store.dispatch("groups/setCheckedTreeGroup", []);
  //     loadingsave.value = false;
  //     router.push({
  //       name: "CheckinType",
  //       query: {
  //         activityID: selectedEvent.value.id,
  //         activityName: selectedEvent.value.name,
  //         groupId: selectedGroups.value[0].id,
  //         groupName: selectedGroups.value[0].name,
  //         id: response.data.returnObject.checkInAttendanceResult[0].id,
  //         code: response.data.returnObject.checkInAttendanceResult[0].attendanceCode,
  //       },
  //     });
  //   } catch (error) {
  //     console.log(error);
  //     loadingsave.value = false;
  //   }
  //   console.log("Only Topppp");
  // } else if (
  //   attendanceCheID.value
  // ) {
  //   selectedGroups.value
  //     ? formData.append("groupIDs", JSON.stringify(selectedGroups.value))
  //     : "";
  //   attendanceCheID.value
  //     ? formData.append("Id", attendanceCheID.value)
  //     : "";
  //   loadingsave.value = true;
  //   try {
  //     const res = await axios.put(
  //       "/api/CheckInAttendance/EditAttendanceCheckIn",
  //       formData
  //     );
  //     console.log(res);
  //     store.dispatch("attendance/setItemData", res);
  //     ElMessage({
  //               type: "success",
  //               message: res.data.response,
  //               duration: 5000
  //               });
  //               store.dispatch('attendance/setAttendanceItemData');
  //     router.push({
  //       name: "CheckinType",
  //       query: {
  //         activityID: selectedEvent.value.id,
  //         activityName: selectedEvent.value.name,
  //         groupId: selectedGroups.value[0].id,
  //         groupName: selectedGroups.value[0].name,
  //         id: res.data.id,
  //         code: res.data.attendanceCode,
  //       },
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // } else if (
  //   !amount.value &&
  //   !selectedBank.value &&
  //   !accountNumber.value &&
  //   !selectedCashAccount.value &&
  //   !selectedIncomeAccount.value &&
  //   image.value
  // ) {
  //   console.log("Free and image");
  //   selectedGroups.value
  //     ? formData.append("groupIDs", JSON.stringify(selectedGroups.value))
  //     : "";
  //   loadingsave.value = true;
  //   try {
  //     let { data } = await axios.post(
  //       // "/api/CheckInAttendance/create/multiple",
  //       "api/CheckInAttendance/CreateAttendanceCheckIn",
  //       formData
  //     );
  //     let firstGroup = data.returnObject.checkInAttendanceResult.find(
  //       (i) => i.groupID == selectedGroups.value[0].id
  //     );

  //     for (
  //       let i = 0;
  //       i < data.returnObject.checkInAttendanceResult.length;
  //       i++
  //     ) {
  //       const element = data.returnObject.checkInAttendanceResult[i];
  //       store.dispatch("attendance/setEventReg", element);
  //     }
  //     store.dispatch('attendance/setAttendanceItemData');
  //     loadingsave.value = false;
  //     router.push({
  //       name: "CheckinType",
  //       query: {
  //         activityID: selectedEvent.value.id,
  //         activityName: selectedEvent.value.name,
  //         groupId: firstGroup.id,
  //         groupName: selectedGroups.value[0].name,
  //         id: firstGroup.id,
  //         code: firstGroup.attendanceCode,
  //       },
  //     });
  //   } catch (err) {
  //     console.log(err);
  //     loadingsave.value = false;
  //   }
  // } else if (
  //   amount.value &&
  //   selectedBank.value &&
  //   accountNumber.value &&
  //   selectedCashAccount.value &&
  //   selectedIncomeAccount.value
  // ) {
  //   console.log("image and paid");
  //   selectedGroups.value
  //     ? formData.append("groupIDs", JSON.stringify(selectedGroups.value))
  //     : "";
  //   loadingsave.value = true;
  //   try {
  //     let { data } = await axios.post(
  //       "api/CheckInAttendance/CreateAttendanceCheckIn",
  //       // "/api/CheckInAttendance/create/multiple",
  //       formData
  //     );
  //     let firstGroup = data.returnObject.checkInAttendanceResult.find(
  //       (i) => i.groupID == selectedGroups.value[0].id
  //     );
  //     store.dispatch('attendance/setAttendanceItemData');

  //     for (
  //       let i = 0;
  //       i < data.returnObject.checkInAttendanceResult.length;
  //       i++
  //     ) {
  //       const element = data.returnObject.checkInAttendanceResult[i];
  //       store.dispatch("attendance/setEventReg", element);
  //     }
  //     loadingsave.value = false;
  //     router.push({
  //       name: "CheckinType",
  //       query: {
  //         activityID: selectedEvent.value.id,
  //         activityName: selectedEvent.value.name,
  //         groupId: firstGroup.id,
  //         groupName: selectedGroups.value[0].name,
  //         id: firstGroup.id,
  //         code: firstGroup.attendanceCode,
  //       },
  //     });
  //   } catch (err) {
  //     console.log(err);
  //     loading.value = false;
  //   }
  // } else {
  //   ElMessage({
  //             type: "warning",
  //             message: 'Cannot create this event attendance, kindly fill all fields before saving.',
  //             duration: 5000
  //           });
  //   loadingsave.value = false;
  // }
};

const showPaidTab = () => {
  addPaidClass.value = true;
  addFreeClass.value = false;
};

const showFreeTab = () => {
  addFreeClass.value = true;
  addPaidClass.value = false;
};

const toggleTemplate = () => {
  templateDisplay.value = !templateDisplay.value;
};

const getBanks = () => {
  axios
    .get("/api/Financials/GetBanks")
    .then((res) => {
      nigerianBanks.value = res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
getBanks();

const resolveCustomerDetail = async () => {
  loading.value = true;
  try {
    let header = {
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_PAYSTACK_SECRET_KEY}`,
      },
    };

    let { data } = await axio.get(
      `https://api.paystack.co/bank/resolve?account_number=${accountNumber.value}&bank_code=${selectedBank.value.code}`,
      header
    );
    accountName.value = data.data.account_name;
    // accNameRef.value.focus();
    // disabled.value = false

    loading.value = false;

    ElNotification({
      type: "success",
      message: "Account Check Successful",
      duration: 5000,
    });
  } catch (error) {
    finish();
    console.log(error);

    loading.value = false;

    ElNotification({
      type: "error",
      message: "Account Check Error, Please check your banks details again ",
      duration: 5000,
    });
  }
};

const getCashBankAccount = () => {
  axios
    .get("/api/financials/accounts/getcashbankaccounts")
    .then((res) => {
      cashBankAccount.value = res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
getCashBankAccount();

const getIncomeAccount = () => {
  axios
    .get("/api/Financials/Accounts/GetIncomeAccounts")
    .then((res) => {
      incomeAccount.value = res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
getIncomeAccount();

const altClick = () => {
  binImage.value.click();
};

const chooseFile = (e) => {
  image.value = e.target.files[0];
  imageUrl.value = URL.createObjectURL(image.value);
};

const setBank = (item) => {
  selectedBank.value = item;
};

const setGroupProp = () => {
  hideDiv.value = !hideDiv.value;
  nextTick(() => {
    searchGroupRef.value.focus();
  });
};

const searchForGroups = computed(() => {
  if (!searchGroupText.value.name && groups.value.length > 0)
    return groups.value;
  return groups.value.filter((i) =>
    i.name.toLowerCase().includes(searchGroupText.value.toLowerCase())
  );
});

const closeDropdownIfOpen = (e) => {
  if (
    !e.target.classList.contains("exempt-hide") &&
    !e.target.classList.contains("p-hidden-accessible") &&
    !e.target.classList.contains("p-checkbox-box") &&
    !e.target.classList.contains("p-checkbox-icon")
  ) {
    // hideDiv.value = true;
  }
};

const setFilterGroups = (payload) => {
  selectedGroups.value = payload;
};

const setNewGroup = (payload) => {
  groups.value.push(payload);
};

const setSelectedSenderIdCheckin = (payload) => {
  checkinSMSSubject.value = payload;
};

const setSelectedSenderIdRegistration = (payload) => {
  registrationSMSSubject.value = payload;
};
</script>

<style scoped>
* {
  color: #02172e;
  /* font-family: Nunito Sans !important; */
}
.amount-input-group {
  display: flex;
  gap: 0;
}
.currency-select {
  width: 100px;
  flex-shrink: 0;
}
.amount-input {
  flex: 1;
}
:deep(.currency-select .el-input__wrapper) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}

:deep(.amount-input .el-input__wrapper) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.default-bt {
  font-weight: 600 !important;
  white-space: initial;
  border-radius: 3rem;
  border: 0.6px solid #0040ff !important;
  /* padding: 0.5rem 1.25rem; */
  /* width: auto; */
  outline: transparent !important;
  height: 40px !important;
  background: #fff;
  /* min-width: 121px; */
  /* width: 105px !important; */
  display: flex !important;
  align-items: center !important;
  /* justify-content: center !important; */
}

.upload-area {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  background-color: #ebedff;
}
.upload-area-btn {
  /* display: flex; */
  /* justify-content: center;
  align-items: center; */
  /* height: 150px; */
  border: 2px dashed #0745af !important;
  color: #0745af !important;
  /* border-radius: 20px;
  cursor: pointer;
  text-align: center; */
}

.upload-box {
  color: #007bff;
  font-weight: bold;
}

.border-contribution {
  border: 1.6px solid rgb(229, 232, 237);
  border-radius: 4px;
  padding: 11px 7px;
}

.contn-btn:disabled {
  opacity: 0.3;
}

.menu-height {
  max-height: 400px;
  overflow: scroll;
}

.upload-button {
  background: rgba(206, 206, 206, 0.274);
  color: black;
  /* border-radius: 25px; */
  font-weight: 600;
  padding: 8px 10px;
}

.active-tab {
  border-bottom: 2px solid rgb(31, 87, 241);
}

.header-contri {
  font-size: 20px;
  font-weight: 700;
}
/* .img-border {
  border: 1px dotted rgb(206, 212, 218); 
  height: 150px;
} */

.show-paid {
  height: 327px;
  /* overflow: hidden; */
  transition: all 0.6s ease-in-out;
}

.hide-paid {
  height: 0;
  overflow: hidden;
  transition: all 0.6s ease-in-out;
}

.input-width {
  width: 100%;
}

.input-width {
  width: 100%;
}

@media (min-width: 992px) {
  .input-width {
    width: 350px;
  }
}

@media (max-width: 576px) {
  .show-tem-free {
    height: 1241px;
  }

  .show-tem {
    height: 1774px;
    /* overflow: hidden; */
    transition: all 1s ease-in-out;
  }

  .show-paid {
    height: 560px;
    /* overflow: hidden; */
    transition: all 0.6s ease-in-out;
  }
}

.show-amount {
  /* width: 100%;
  overflow: hidden; */
  transform: translateX(0px);
  opacity: 1;
  transition: all 0.6s ease-in-out;
}

.hide-amount {
  opacity: 0;
  transition: all 0.6s ease-in-out;
}

#second {
  width: 100%;
}

.div-card {
  position: absolute;
  background: white;
  z-index: 1;
  width: 100%;
  top: 40px;
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
  max-height: 400px;
  overflow: scroll;
}

.eachGroup {
  padding: 5px 10px;
  background: #eee;
  border-radius: 25px;
  margin: 0 3px;
}

.angle-icon {
  border: 1px solid #dde2e6;
  padding: 2px;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  color: #91949c;
}
</style>
